module.exports = __webpack_public_path__ + "img/hr-green-hairy-grass-15.29cedbad.png";